export default import.meta.ROLLUP_FILE_URL_nQ3gmh9JIZv1byz1C3w0uw